module.exports = __webpack_public_path__ + "img/upload_content.a0b82182.png";